<template lang="pug">
  .user-add__container
    .user-add__input
      .title Имя пользователя
      el-input(v-model="addingUser.name" placeholder="Введите логин")
    .user-add__input
      .title Пароль
      el-input(v-model="addingUser.password" placeholder="Введите пароль" type="password")
    .user-add__input(v-if="isAdmin")
      .title Роль
      el-select(v-model="addingUser.role")
        el-option(v-for="(label, role) in roles" :value="role" :label="label" :key="`user-add-role-${role}`")
    .user-add__input(v-if="isAdmin && addingUser.role === 'support'")
      .title Лимит закрытия
      el-input(v-model="addingUser.support_limit_max" type="number")
    .user-add__buttons
      el-button(type="success" @click="addOrEditUser()") Сохранить
      el-button(type="danger" @click="resetUserAdd()") Отменить
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
  import { CREATE_USER } from "../../store/const/user";

  export default {
    name: 'AddUser',
    props: {
      roles: { type: Object, default: () => {} },
    },
    data() {
      return {
        addingUser: {
          name: '',
          password: '',
          role: 'admin',
          support_limit_max: 0,
        },
      }
    },
    computed: {
      ...mapGetters('user', [
        'isAdmin'
      ]),
    },
    methods: {
      ...mapActions('user', {
        addNewUser: CREATE_USER,
      }),
      async addOrEditUser() {
        if (!this.addingUser.name || !this.addingUser.password) {
          this.$message.info('Необходимо заполнить все поля');
          return;
        } else if (this.addingUser.password.length < 7) {
          this.$message.info('Минимальная длина пароля 7 символов');
          return;
        }
        const request = await this.addNewUser(this.addingUser);
        if (request.success) {
          this.$message.success('Пользователь успешно добавлен');
          this.$emit('updateUsers');
          this.resetUserAdd();
        } else {
          this.$message.error(`Ошибка добавления пользователя: ${request.message || 'Неизвестная ошибка'}`);
        }
      },
      resetUserAdd() {
        this.$emit('resetUserAdd');
      }
    }
  };
</script>
<style scoped>
  .user-add__input {
    margin: 5px;
  }

  .user-add__input .title {
    margin-bottom: 5px;
  }

  .user-add__buttons {
    margin-top: 5px;
  }
</style>
